import { ManageBooking } from './manage_booking';

export default ManageBooking;
